export default "Ist\noder\nWo\nWas\nWie\nwie viele\nwie viel\nsollen\ndürfen"